import { TimeSection } from '../types'

/**
 * Get the current time section based on day of week and time of day
 * Morning: 00:00-11:59
 * Afternoon: 12:00-23:59
 *
 * @param now - Optional date to check (defaults to current time)
 * @returns The current time section
 */
export function getCurrentTimeSection(now: Date = new Date()): TimeSection {
  const dayOfWeek = now.getDay() // 0 = Sunday, 6 = Saturday
  const hours = now.getHours()
  const isMorning = hours < 12

  // Map day of week to time section
  // Sunday = 0, Monday = 1, ..., Saturday = 6
  const dayMap: Record<number, string> = {
    0: 'SUN',
    1: 'MON',
    2: 'TUE',
    3: 'WED',
    4: 'THU',
    5: 'FRI',
    6: 'SAT',
  }

  const dayPrefix = dayMap[dayOfWeek]
  const timePeriod = isMorning ? 'MORNING' : 'AFTERNOON'

  return `${dayPrefix}_${timePeriod}` as TimeSection
}
